{
    "FileUpload_DragAndDrop": "Trascina il file qui o clicca per selezionarlo",
    "FileUpload_DropFileHere": "Trascina il file qui",
    "FileUpload_Accepted": "Il file verrà accettato",
    "FileUpload_Rejected": "Il file verrà rifiutato",
    "FileUpload_SelectedFile": "File selezionato: {}",
    "FileUpload_Validation_OverMaxSize": "La dimensione del file supera la dimensione massima consentita di {}",
    "FileUpload_Validation_MaxDimensions": "Le dimensioni del file superano le dimensioni massime consentite di {}x{}",
    "FileUpload_Validation_MinDimensions": "Le dimensioni del file sono inferiori alle dimensioni minime consentite di {}x{}",
    "FileUpload_Validation_NotTransparent": "Lo sfondo del file non è trasparente",
    "NAME": "FileUploadLanguage"
}